import React from 'react'

const CommentComp = (props)=> {
    return (
    <>
        {props.data && props.data.length>0 &&
        <ul className="note-list">
            <div className="title-text">Notes</div>
            {props.data.map((item,idx)=>(
                <li key={idx}>
                    <div>
                        <div className="note-item">
                        <div className="note-header">
                            <span className="note-time">
                            {item.commentTime}
                            </span>
                            <span className="note-title strong">
                            {item.user}
                            </span>
                        </div>
                        <div className="note-body">
                            {item.comment}
                        </div>
                        </div>
                    </div>
                </li>

            ))}
        </ul>
        }
    </>
    )
}

export default CommentComp
